module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor10-d5d5abac38c60d39bde59965c99bc29e.png";